var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabaseBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 68.165,
    width: 63.257,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.163 21.154c-.35-.049-1.69-.197-2.975-.33C12.33 19.81 3.403 16.302 1.81 12.816c-1.463-3.2 2.38-6.503 10.286-8.843 5.55-1.643 11.89-2.42 19.656-2.408C42.13 1.579 50.83 3.16 56.619 6.083c5.557 2.805 6.546 6.008 2.767 8.957-3.427 2.675-9.209 4.554-17.582 5.715-2.463.342-14.897.64-16.64.399z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.08184352,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12 36.052c-3.828-.216-9.162-.891-12.262-1.552-6.383-1.36-11.534-4.033-13.079-6.79l-.536-.956.057-6.07.056-6.069 1.16.911c2.357 1.852 6.654 3.623 11.562 4.765 16.618 3.868 38.567 1.525 46.769-4.991l1.122-.892v5.863c0 5.683-.015 5.899-.504 6.991-1.742 3.913-8.82 6.995-18.95 8.254-2.587.321-10.133.82-11.438.755-.353-.018-2.133-.116-3.955-.22z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.082621,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.092 66.417c-10.866-.891-18.482-3.25-21.937-6.794-1.606-1.646-1.574-1.47-1.51-8.272l.056-6.053 1.263.995c5.119 4.034 15.99 6.466 28.902 6.466 13.173 0 23.65-2.464 28.697-6.748l1.15-.976v5.904c-.011 6.864-.039 7.013-2.015 8.993-3.374 3.378-11.012 5.701-21.371 6.5-3.392.26-9.962.254-13.23-.012z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0816793,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.178 51.373c-11.007-.763-18.999-3.1-22.675-6.63-1.863-1.787-1.845-1.704-1.845-8.774V29.82l.97.897c5.18 4.79 20.73 7.745 35.176 6.683 10.803-.794 18.07-2.87 22.485-6.426l1.402-1.128v5.724c0 3.485-.093 6.068-.234 6.605-.37 1.402-2.825 3.809-5.05 4.952-6.53 3.355-18.603 5.05-30.227 4.245z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.08188388,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.363 11.338A30.735 10.444 0 0 1 31.63 21.782 30.735 10.444 0 0 1 .894 11.338 30.735 10.444 0 0 1 31.629.894a30.735 10.444 0 0 1 30.734 10.444Z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 0.84079602,
      stroke: "#161616",
      strokeWidth: 1.78799975,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.915 41.999c-.027.686 1.635 9.529 30.928 10.109 30.49-.528 30.52-10.404 30.52-10.404M.915 57.162c-.027.686 1.635 9.529 30.928 10.11 30.49-.528 30.52-10.405 30.52-10.405M.915 26.836c-.027.686 1.635 9.528 30.928 10.109 30.49-.528 30.52-10.404 30.52-10.404M.915 57.162V10.98m61.448 45.887v-46.18",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 0.84079602,
      stroke: "#161616",
      strokeWidth: 1.78799975,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseBw);
export default __webpack_public_path__ + "static/media/DatabaseBW.04a43dcbd8dbed2f74dd883ce2684f8a.svg";
export { ForwardRef as ReactComponent };